import * as Yup from 'yup';

export default Yup.object().shape({
  start_date: Yup.string().required(),
  end_date: Yup.string().required(),
});
